import Vue from 'vue'
import Vuex from 'vuex'
import axios from './axios-auth'
import router from './router'

Vue.use(Vuex)

export default new Vuex.Store({
  data: {
    logouttimer: null,
    pullerInterval: null,
  },
  state: {
    idToken: null,
    userId: null,
    name: null,
    noBankID: false,
    updateAML: false,
    forceAML: false,
    extraAML: false,
    ownerFilter: null,
    messages: null,
  },
  mutations: {
    authUser (state, userData) {
      state.idToken = userData.token
      state.userId = userData.userId
      state.name = userData.name
      state.noBankID = userData.noBankID
      state.updateAML = userData.updateAML
      state.forceAML = userData.forceAML
      state.extraAML = userData.extraAML
    },
    updateMessages (state, mObj) {
      state.messages = mObj
    },
    clearAuthData (state) {

      state.idToken = null
      state.userId = null
      state.ownerFilter = null

      localStorage.removeItem('token')
      localStorage.removeItem('expirationDate')
      localStorage.removeItem('noBankID')
      localStorage.removeItem('updateAML')
      localStorage.removeItem('forceAML')
      localStorage.removeItem('extraAML')
      localStorage.removeItem('name')
      localStorage.removeItem('userId')
      // remove sessionStorage items if any
      sessionStorage.removeItem('ownerFilter')


      clearTimeout(this.logouttimer)
    },
    updateAML(state, status) {
      state.updateAML = status;
    },
    noBankID(state, status) {
        state.noBankID = status;
    },
    updateForceAML(state, status) {
        state.forceAML = status;
    },
    updateExtraAML(state, status) {
        state.extraAML = status;
    },
  },
  actions: {
    setLogoutTimer ({commit}, expirationTime) {

     this.logouttimer = setTimeout(() => {
        commit('clearAuthData')
        router.push('/login')
      },expirationTime);

    },startMessagePuller ({commit}) {

      this.logouttimer = setInterval(() => {

        return axios.post('/halls/messages')
        .then(res => { //console.log(res)
          commit('updateMessages', res.data.messages)
        })
       },30000);

       axios.post('/halls/messages')
        .then(res => { //console.log(res)
          commit('updateMessages', res.data.messages)
        })
 
     },
    login ({commit, dispatch}, authData) {

      return axios.post('/user/login', {
        username: authData.username,
        password: authData.password
        })
      .then(res => { console.log(res)
        
      commit("authUser", {
        token: res.data.token,
        userId: res.data.userId,
        name: res.data.userFirstname,
        noBankID: res.data.noBankID,
        updateAML: res.data.updateAML,
        forceAML: res.data.forceAML,
        extraAML: res.data.extraAML
      })
        dispatch('setLogoutTimer', res.data.expiresIn *1000)
        const now = new Date()
        const expirationDate = new Date(now.getTime() + res.data.expiresIn * 1000)
        localStorage.setItem('token',res.data.token)
        localStorage.setItem('expirationDate', expirationDate)
        localStorage.setItem('noBankID', res.data.noBankID)
        localStorage.setItem('updateAML', res.data.updateAML)
        localStorage.setItem('name', res.data.userFirstname)
        localStorage.setItem('userId', res.data.userId)
        localStorage.setItem('forceAML', res.data.forceAML)
        localStorage.setItem('extraAML', res.data.extraAML)
        return 1
      })
      .catch(error => { console.log(error) 
      
        return 0
      })

      
    },
    tryAutoLogin({commit, dispatch}) {
      const token = localStorage.getItem('token')
      this.state.ownerFilter = sessionStorage.getItem('ownerFilter') ? sessionStorage.getItem('ownerFilter') : null
      if(!token) {
        return
      }

      const expirationDate = new Date(localStorage.getItem('expirationDate'))
      const now = new Date()

      if(now >= expirationDate) {
        return
      }

      const _noBankID = localStorage.getItem('noBankID') == 'true' ? true : false
      const _updateAML = localStorage.getItem('updateAML') == 'true' ? true : false
      const _forceAML = localStorage.getItem('forceAML') == 'true' ? true : false
      const _extraAML = localStorage.getItem('extraAML') == 'true' ? true : false
      commit("authUser", {
        token: token,
        userId: localStorage.getItem('userId'),
        name: localStorage.getItem('name'),
        noBankID: _noBankID,
        updateAML: _updateAML,
        forceAML: _forceAML,
        extraAML: _extraAML

      })
      dispatch('setLogoutTimer', expirationDate - now)

      console.log("Autologin");



    },
    logout ({commit}) {

      commit('clearAuthData')

    }


  },
  getters: {
    isAuthenticated (state) {
      return state.idToken !== null
    },
    getMessages(state) {

      return state.messages

    }
  }
})